import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';

export default function accountAssertionsReducer(
	state = initialstate.accountAssertions,
	action
) {
	switch (action.type) {
		case types.GET_ASSERTIONS_FOR_ACCOUNTID: {
			let newstate = [];

			if (state && state.length > 0) {
				let filteredAssertions = _.filter(state, function(assertion) {
					return assertion.accountId !== action.response[0].accountId;
				});

				newstate.push(...filteredAssertions, action.response[0]);
			} else {
				newstate.push(action.response[0]);
			}

			return newstate || state;
		}
		default:
			return state;
	}
}
